import React, {useState} from 'react';
import {View} from 'react-native';
import {observer} from 'mobx-react-lite';

import OrderDetails from '../../../../components/checkout/OrderDetails';
import InputModal from '../../../../components/checkout/OrderDetails/InputModal';
import OrderNotes from '../../../../components/checkout/OrderDetails/OrderNotes';
import PickupDeliverComponent from '../../../../components/pickupDeliver/PickupDeliverComponent';
import {useStores} from '../../../../stores/use-stores';
import type {StepContentProps} from '../types';

/**
 * Left side content for Checkout (Delivery) step (Mode B)
 *
 * Contains:
 * - Delivery/Pickup selection
 * - Order details form
 * - Order notes
 */
const CheckoutContent = observer((_props: StepContentProps) => {
  const {cartStore} = useStores();
  const [isOrderNotesModalVisible, setIsOrderNotesModalVisible] = useState(false);

  const saveOrderNote = (value: string) => {
    cartStore.setOrderNotes(value);
    cartStore.updateOrderNotes();
    setIsOrderNotesModalVisible(false);
  };

  return (
    <View style={{gap: 16}}>
      <PickupDeliverComponent />

      <OrderDetails />

      <InputModal
        element={({onPress}) => (
          <OrderNotes
            onPress={onPress}
            notes={cartStore.orderNotes || 'Add note to store'}
            testID="checkout-content-order-notes"
          />
        )}
        isVisible={isOrderNotesModalVisible}
        title="Add note to store"
        saveAction={saveOrderNote}
        saveText="UPDATE"
        closeAction={() => setIsOrderNotesModalVisible(false)}
        openAction={() => setIsOrderNotesModalVisible(true)}
        initialValue={cartStore.orderNotes}
        label="Order note"
        helperText="Add any special instructions for the store"
        placeholder="e.g. Please leave at door"
      />
    </View>
  );
});

export default CheckoutContent;
